import React from 'react';

import classNames from 'classnames';

import { RadioProps } from './Radio.interface';

const getRadioClasses = (isDisabled?: boolean, className?: string): string =>
  classNames(
    'rds-radio',
    {
      'is-rds-disabled': isDisabled,
    },
    className,
  );

const getRadioIconClasses = (colorBranded: boolean): string =>
  classNames('rds-radio-icon', {
    'is-white-labeled-primary-color': colorBranded,
  });

const RdsRadio = React.forwardRef<
  HTMLInputElement, // The reference type - which element the final ref is attached to.
  RadioProps
>(
  (
    {
      children,
      className,
      id,
      isChecked,
      isDefaultChecked,
      isDisabled,
      isRequired,
      name,
      onChange,
      value,
      colorBranded = true,
      ...others
    },
    forwardedRef,
  ) => {
    return (
      <label
        {...others}
        className={getRadioClasses(isDisabled, className)}
        htmlFor={id}
      >
        <input
          checked={isChecked}
          defaultChecked={isDefaultChecked}
          disabled={isDisabled}
          id={id}
          name={name}
          onChange={onChange}
          ref={forwardedRef}
          required={isRequired}
          type="radio"
          value={value}
        />
        <span className={getRadioIconClasses(colorBranded)}></span>
        <span>{children}</span>
      </label>
    );
  },
);

export default RdsRadio;
